import React from 'react';
import PropTypes from 'prop-types';

export function Row({ children, className, isMain, isSub, hasBorder, hasPaddingBottom, onComponentClick }) {
    const defaultClassNames = [
        'sidebar__row',
        isMain && 'sidebar__row--main',
        isSub && 'sidebar__row--sub',
        !hasBorder && 'sidebar__row--no-border',
        !hasPaddingBottom && 'sidebar__row--no-padding-bottom',
    ];

    const classNames = [ ...defaultClassNames, className ]
        .filter(val => !!val)
        .join(' ');

    return (
        <tr className={classNames} onClick={onComponentClick}>
            {children}
        </tr>
    );
}

Row.propTypes = {
    className: PropTypes.string,
    isMain: PropTypes.bool,
    isSub: PropTypes.bool,
    hasBorder: PropTypes.bool,
    hasPaddingBottom: PropTypes.bool,
};

Row.defaultProps = {
    className: '',
    isMain: false,
    isSub: false,
    hasBorder: true,
    hasPaddingBottom: true,
};
